import { Component, Input, OnInit } from "@angular/core";
import { FuseTranslationLoaderService } from 'app/core/services/translation-loader.service';
import { locale as danish } from "./translate/ds";
import { locale as english } from "./translate/en";
import { SettingsService } from '../../settings.service';
import { ResponseBase } from "app/main/model/ResponseBase";
import { Settings } from "app/main/model/Settings";

@Component({
    selector: "settings-coworker-economy",
    templateUrl: "./coworker-economy.component.html",
    styleUrls: ["./coworker-economy.component.scss"]
})

export class CoworkerEconomySettingsComponent implements OnInit {
    showSpinner: boolean = false;
    @Input() projectSettings: any;
    coworkerPrice: number = 0;
    coworkerPriceObj: Settings;
    constructor(private translationLoaderService: FuseTranslationLoaderService,
        private settingsService: SettingsService) {
        this.translationLoaderService.loadTranslations(danish, english);
    }

    ngOnInit() {
        if (this.projectSettings && this.projectSettings.length > 0) {
            var tempSettingObject = this.projectSettings.find(s => s.key1 == "Project" && s.key2 == "CoworkerPrice");
            if (tempSettingObject) {
                this.coworkerPriceObj = tempSettingObject;
                this.coworkerPrice = Number(tempSettingObject.value);
            }
        }
        else
            this.getSettingsForCoworkerEconomyDetails();
    }

    getSettingsForCoworkerEconomyDetails() {
        this.showSpinner = true;
        this.settingsService.GetSettingsValue<ResponseBase>("Project", "CoworkerPrice",null).subscribe({
            next: (response: ResponseBase) => {
                this.showSpinner = false;
                if (response != null && response.result && response.result.myResponse.length > 0) {
                    this.coworkerPriceObj = response.result.myResponse[0];
                    this.coworkerPrice = Number(response.result.myResponse[0].value);
                }
            },
            error: err => {
            },
            complete: () => {
                this.showSpinner = false;
            }
        });
    }

    changeSettingsForCoworkerEconomyDetails() {
        this.showSpinner = true;
        this.coworkerPriceObj.value = this.coworkerPrice ? this.coworkerPrice.toString() : "";
        this.settingsService.UpdateSettingValue<ResponseBase>(this.coworkerPriceObj).subscribe({
            next: (response: ResponseBase) => {
                this.showSpinner = false;
                if (response != null && response.result) 
                    this.coworkerPriceObj = response.result;
            },
            error: err => {
            },
            complete: () => {
                this.showSpinner = false;
            }
        });
    }
}